import { render } from "./ReferralModulesSettingsOverlay.vue?vue&type=template&id=78b6d3cd&scoped=true&lang=pug"
import script from "./ReferralModulesSettingsOverlay.vue?vue&type=script&lang=js"
export * from "./ReferralModulesSettingsOverlay.vue?vue&type=script&lang=js"

import "./ReferralModulesSettingsOverlay.vue?vue&type=style&index=0&id=78b6d3cd&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78b6d3cd"]])

export default __exports__